<template>
  <div class="accessDoorControlGateList w-full h-full relative">
    <div class="icon-search__input mt-5px mb-5px">
      <el-input class="w-full" placeholder="请输入设备名称" v-model="keyWords" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="getIotDevicePagedList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 100px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column :label="`${$t('设备名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('类型')}`" show-overflow-tooltip prop="deviceTypeDesc">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15 cursor-pointer text-[#00BCC8]" @click="reviewDetail(row, true)">
            查看
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getIotDevicePagedList()"
      :pager-count="5"
    >
    </el-pagination>
    <DccessRecordDialog
      :deviceId="deviceId"
      :deviceType="deviceType"
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></DccessRecordDialog>
  </div>
</template>

<script>
import { WisdomSecurityApi } from '@wiz-api/huizhou2'
import { findIndex } from 'lodash'

const wisdomSecurityApi = new WisdomSecurityApi()
const DccessRecordDialog = () => {
  return import('./accessRecordDialog')
}
export default {
  name: 'accessDoorControlGateList',
  components: {
    DccessRecordDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {},
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    'transferProps.deviceId': {
      handler(val) {
        if (val) {
          this.reviewDetail(this.transferProps)
        }
      },
      deep: true,
    },
  },
  created() {
    this.switchMarker(true)
    if (this.transferProps?.deviceId) {
      this.reviewDetail(this.transferProps)
    }
    this.getIotDevicePagedList()
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 15,
      pageNo: 1,
      isShowDialog: false,
      keyWords: '',
      deviceId: '',
      deviceType: 2,
    }
  },
  methods: {
    // 关闭/开启标记
    switchMarker(show) {
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code: 'AccessList',
          checked: show,
        },
      })
      window.dispatchEvent(event)
    },
    async getIotDevicePagedList() {
      const [err, res] = await wisdomSecurityApi.getIotDevicePagedList({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          DeviceType: [2],
          areaCode: '',
          keyWords: this.keyWords,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    async reviewDetail(item, needToLocate = false) {
      this.isShowDialog = true
      this.deviceId = item.deviceId
      this.deviceType = item.deviceType === 'AccessControl' ? 2 : 3
      // 只对列表点击查看详情做定位，其他情况已有定位操作，避免重复
      if (needToLocate && this.player) {
        const str = sessionStorage.getItem('accessMarkList')
        if (str && JSON.parse(str).length) {
          const markList = JSON.parse(str)
          const index = findIndex(markList, ['id', item.deviceId])
          if (index > -1) {
            const treeData = await this.player.Native.ModelTree.getRootItems()
            this.player?.Native.Camera.moveToPos(
              JSON.parse(markList[index].threeDPosition),
              treeData[0]?.nodePtr,
              50,
              2
            )
          }
        }
      }
    },
    refresh() {
      this.isShowDialog = false
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.player.Native.Camera.moveTo(cameraParams.eye, cameraParams.target, cameraParams.up, 2)
      }
    },
  },
  beforeDestroy() {
    this.backInitPositon()
    this.switchMarker(false)
  },
}
</script>
<style lang="scss" scoped></style>
